(function($){

	var homeHeroSlider = function() {
		$('.hero-slider').slick({
			arrows: false,
			// prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points="20.77 70 8.15 35.01 20.93 0 13.02 0 0 35 13.02 70 20.77 70"/></svg></button>',
			// nextArrow: '<button class="slick-arrow slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points=".16 0 12.78 34.99 0 70 7.91 70 20.93 35 7.91 0 .16 0"/></svg></button>',
			dots: false,
			fade: true,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false,
			lazyLoad: 'ondemand',
		});
	};

	var heroVideo = function() {

		$('[data-action="hero-popup-play"]').on('click', function(e) {
			e.preventDefault();

			var heroVideoModal = document.getElementById('hero-video-modal');
			var heroVideoModalObj = $('#hero-video-modal');

			$.magnificPopup.open({
				mainClass: 'hero-popup',
				items: {
					src: '#hero-video-modal-container',
					type: 'inline',
				},
				callbacks: {
					open: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.play();
						}
					},
					close: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.pause();
							heroVideoModal.currentTime = 0;
						}
					},
				}
			}, 0);
			
		});
		
		$('[data-action="hero-popup-embed"]').magnificPopup({
			type: 'iframe',
			// mainClass: 'hero-popup'
		});

	};


	var scrollAnim = function(){

		///** convert to use intersectionObserver **///

		var win = $(window);

		var items = $('.scroll-animate-item');

		var itemScrollCheck = function(){

			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * .8) + winTop;

			items.each(function(i, el){

				var item = $(el);
				var itemTop = item.offset().top;

				if(itemTop <= scrollTriggerPos){
					item.addClass('vis');
				}
				else{
					item.removeClass('vis');
				}

			});

		};

		itemScrollCheck();
		optimizedScroll.add(itemScrollCheck);
	};


	var scrollToAnchor = function(){

		if( location.hash ){
			// window.scrollTo(0,0);

			$( 'body' ).removeClass( 'nav-open' );
			
			var locationHashObj = $(location.hash);
			
			if(locationHashObj.length > 0){
				//$('body').removeClass('nav-open');
				// $('body,html').animate({
				// 	scrollTop: locationHashObj.offset().top - 150
				// }, 500);

				var waitTime = 501;

				if(!$('body').hasClass('scrolled')){
					waitTime = 501;
					$('body').addClass('scrolled');
				}

				setTimeout(function(){
					var anchorPosition = locationHashObj.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
					$("html, body").animate({scrollTop: finalPosition}, 1000);


				}, waitTime);
			}
		}

		$('.scroll-to-anchor a, a[href^="#"]').on('click', function(e){

			if($(this).hasClass('no-scroll')){
				return;
			}
			else if(this.hash){
				
				var hashTarget = $(this.hash);

				if( hashTarget.length ){
					e.preventDefault();
					var waitTime = 0;
					
					if(!$('body').hasClass('scrolled')){
						waitTime = 501;
						$('body').addClass('scrolled');
					}

					setTimeout(function(){
						var anchorPosition = hashTarget.offset().top;
						var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
						$("html, body").animate({scrollTop: finalPosition}, 1000);

						$( 'body' ).removeClass( 'nav-open' );

					}, waitTime);
				}
			}
		});
	};

	var blockGallery = function() {
		$('.wp-block-gallery').magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		});
	};

	var faqs = function() {

		$('[data-action="faq"]').on('click', function(e) {
			e.preventDefault();

			$(this).toggleClass('open');
		});
	};

	var reviewsSlider = function() {
		if($('.reviews-slider').length) {
			$('.reviews-slider').slick({
				dots: false,
				arrows: true,
				prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="38" viewBox="0 0 21 38" fill="none"><path d="M21 0H12.6116L0 19.0075L12.6116 38H21L8.34504 19.0075L21 0Z" fill="black"/></svg></button>',
				nextArrow: '<button class="slick-arrow slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="38" viewBox="0 0 21 38" fill="none"><path d="M0 0H8.38843L21 19.0075L8.38843 38H0L12.655 19.0075L0 0Z" fill="black"/></svg></button>',
				autoplay: true,
				autoplaySpeed: 6000,
				pauseOnHover: true,
				adaptiveHeight: true,
				speed: 600,
			});
		}
	};


	var practiceAreaCardExpand = function(){
		$('.practice-areas-grid').on('click', '.card-more', function(){
			var btn = $(this);
			var card = btn.closest('.practice-area-card');
			var expanded = card.toggleClass('is-expanded').hasClass('is-expanded');
			btn.attr('aria-expanded', expanded ? 'true' : 'false');
		});
	};

	var practiceAreaFAQ = function(){
		$('.pa-faq-list').on('click', '.pa-faq-question', function(){
			var btn = $(this);
			var item = btn.closest('.pa-faq-item');
			var open = item.toggleClass('is-open').hasClass('is-open');
			btn.attr('aria-expanded', open ? 'true' : 'false');
		});
	};

	// Service Areas map. Every pane (statewide + one per region) is rendered by
	// template-service-areas.php, so the copy is in the DOM for crawlers; this only
	// swaps which pane is showing and dims the counties outside the chosen region.
	var serviceAreaMap = function(){
		var section = document.querySelector('.hsm');
		if(!section) return;

		var svg      = section.querySelector('svg.hsm-map');
		var frame    = section.querySelector('.hsm-mapframe');
		var tip      = section.querySelector('.hsm-tip');
		var counties = section.querySelectorAll('path.county');
		var pills    = section.querySelectorAll('.hsm-pill');
		var panes    = section.querySelectorAll('.hsm-pane');
		if(!svg || !counties.length) return;

		var selected = null;

		var show = function(region){
			// Clicking the active region (or the Statewide pill) clears the filter.
			selected = region;
			svg.classList.toggle('has-sel', !!region);

			Array.prototype.forEach.call(counties, function(path){
				path.classList.toggle('is-active', !!region && path.getAttribute('data-region') === region);
			});
			Array.prototype.forEach.call(pills, function(pill){
				pill.setAttribute('aria-pressed', pill.getAttribute('data-region') === (region || 'all') ? 'true' : 'false');
			});
			Array.prototype.forEach.call(panes, function(pane){
				pane.classList.remove('is-active');
			});
			Array.prototype.forEach.call(section.querySelectorAll('.hsm-pane[data-pane="' + (region || 'all') + '"]'), function(pane){
				pane.classList.add('is-active');
			});
		};

		Array.prototype.forEach.call(pills, function(pill){
			pill.addEventListener('click', function(){
				var region = pill.getAttribute('data-region');
				show(region === 'all' || region === selected ? null : region);
			});
		});

		Array.prototype.forEach.call(counties, function(path){
			var region = path.getAttribute('data-region');

			var select = function(){ show(region === selected ? null : region); };

			path.addEventListener('click', select);
			path.addEventListener('keydown', function(e){
				if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); select(); }
			});
			path.addEventListener('mouseenter', function(){ path.classList.add('is-hot'); });
			path.addEventListener('mouseleave', function(){
				path.classList.remove('is-hot');
				if(tip) tip.classList.remove('is-vis');
			});
			path.addEventListener('mousemove', function(e){
				if(!tip) return;
				var box = frame.getBoundingClientRect();
				tip.style.left = (e.clientX - box.left) + 'px';
				tip.style.top  = (e.clientY - box.top) + 'px';
				tip.innerHTML  = path.getAttribute('data-county') + ' County<span class="kw">' + path.getAttribute('data-kw') + '</span>';
				tip.classList.add('is-vis');
			});
		});

		// The office label sits on a white plate sized to the text, which isn't
		// measurable until the webfont has landed.
		var label = section.querySelector('.hsm-office .lbl');
		var plate = section.querySelector('.hsm-office .lbl-bg');
		var fitLabel = function(){
			if(!label || !plate) return;
			var box;
			try { box = label.getBBox(); } catch(e){ return; }
			plate.setAttribute('x', (box.x - 6).toFixed(1));
			plate.setAttribute('y', (box.y - 3.5).toFixed(1));
			plate.setAttribute('width', (box.width + 12).toFixed(1));
			plate.setAttribute('height', (box.height + 7).toFixed(1));
		};
		fitLabel();
		if(document.fonts && document.fonts.ready) document.fonts.ready.then(fitLabel);
		$(window).on('load', fitLabel);
	};

	// Home page service-area map. The entrance sequence itself is CSS, gated on the
	// .vis class the scroll system puts on .hsm-preview; this measures the state
	// outline for the trace, runs the region tour while the section is in view, and
	// swaps the caption when a region is hovered.
	var serviceAreaPreview = function(){
		var wrap = document.querySelector('.home-service-areas .hsm-preview');
		if(!wrap) return;

		var svg      = wrap.querySelector('svg.pv-svg');
		var outline  = wrap.querySelector('.pv-outline');
		var caption  = wrap.querySelector('.pv-cap');
		var mapLink  = wrap.querySelector('.pv-map');
		var legend   = wrap.querySelector('.pv-legend');
		var counties = wrap.querySelectorAll('path.county');
		var legends  = wrap.querySelectorAll('.pv-leg');
		if(!svg || !counties.length) return;

		var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

		// The trace needs the path's real length before the dash animation can run.
		if(outline){
			var length = 3600;
			try { length = outline.getTotalLength() || 3600; } catch(e){}
			wrap.style.setProperty('--pv-outline-len', length.toFixed(0));
		}

		// Office label plate, sized to the text once the webfont has landed.
		var label = wrap.querySelector('.pv-office .lbl');
		var plate = wrap.querySelector('.pv-office .lbl-bg');
		var fitLabel = function(){
			if(!label || !plate) return;
			var box;
			try { box = label.getBBox(); } catch(e){ return; }
			plate.setAttribute('x', (box.x - 6).toFixed(1));
			plate.setAttribute('y', (box.y - 3.5).toFixed(1));
			plate.setAttribute('width', (box.width + 12).toFixed(1));
			plate.setAttribute('height', (box.height + 7).toFixed(1));
		};
		fitLabel();
		if(document.fonts && document.fonts.ready) document.fonts.ready.then(fitLabel);
		$(window).on('load', fitLabel);

		// Region order and copy come from the legend, which the template builds
		// from the Service Areas page.
		var regions = [].map.call(legends, function(el){
			return {
				key:  el.getAttribute('data-region'),
				name: el.getAttribute('data-name'),
				tag:  el.getAttribute('data-tag'),
				paths: wrap.querySelectorAll('path.county[data-region="' + el.getAttribute('data-region') + '"]')
			};
		});

		var defaultCaption = caption ? caption.innerHTML : '';
		var setCaption = function(html){
			if(!caption || caption.innerHTML === html) return;
			caption.classList.add('is-swapping');
			setTimeout(function(){
				caption.innerHTML = html;
				caption.classList.remove('is-swapping');
			}, 120);
		};
		var regionCaption = function(region){
			return '<b>' + region.name + '</b> &middot; <i>' + region.tag + '</i>';
		};

		var clearRaised = function(){
			Array.prototype.forEach.call(wrap.querySelectorAll('path.is-raised'), function(p){ p.classList.remove('is-raised'); });
		};

		// Tour: lifts one region at a time while nothing is hovered.
		var raise = function(region){
			clearRaised();
			svg.classList.remove('is-focusing');
			Array.prototype.forEach.call(region.paths, function(p){ p.classList.add('is-raised'); });
			setCaption(regionCaption(region));
		};

		// Hover: dims every region but the one under the pointer.
		var focus = function(key){
			clearRaised();
			svg.classList.add('is-focusing');
			Array.prototype.forEach.call(counties, function(p){
				p.classList.toggle('is-on', p.getAttribute('data-region') === key);
			});
			var region = regions.filter(function(r){ return r.key === key; })[0];
			if(region) setCaption(regionCaption(region));
		};

		var clearFocus = function(){
			svg.classList.remove('is-focusing');
			Array.prototype.forEach.call(wrap.querySelectorAll('path.is-on'), function(p){ p.classList.remove('is-on'); });
			clearRaised();
			setCaption(defaultCaption);
		};

		var timer = null, startTimer = null, index = 0, paused = false;

		var stopTour = function(){
			clearTimeout(startTimer);
			clearInterval(timer);
			timer = startTimer = null;
			index = 0;
			paused = false;
		};

		var startTour = function(){
			if(reduced || timer || !regions.length) return;
			var tick = function(){
				if(paused) return;
				raise(regions[index]);
				index = (index + 1) % regions.length;
			};
			tick();
			timer = setInterval(tick, 1900);
		};

		Array.prototype.forEach.call(counties, function(path){
			path.addEventListener('mouseenter', function(){ paused = true; focus(path.getAttribute('data-region')); });
		});
		Array.prototype.forEach.call(legends, function(el){
			el.addEventListener('mouseenter', function(){ paused = true; focus(el.getAttribute('data-region')); });
			el.addEventListener('click', function(){ if(mapLink && mapLink.href) window.location.href = mapLink.href; });
		});
		[mapLink, legend].forEach(function(node){
			if(node) node.addEventListener('mouseleave', function(){ paused = false; clearFocus(); });
		});

		// The scroll system toggles .vis as the section enters and leaves the
		// viewport; the tour follows it so the whole sequence replays on the way
		// back up, and nothing ticks while the section is off screen.
		var sync = function(){
			if(wrap.classList.contains('vis')){
				// Held until the caption's own reveal (1.9s delay + 0.6s) has
				// finished, so the first swap isn't overridden by it.
				if(!timer && !startTimer) startTimer = setTimeout(startTour, 2600);
			} else {
				stopTour();
				clearFocus();
			}
		};
		new MutationObserver(sync).observe(wrap, { attributes: true, attributeFilter: ['class'] });
		sync();
	};

	// Practice Areas mega menu — hover intent. The full-width panel drops from the
	// bottom of the (tall) header, so there's a vertical gap between the nav item
	// and the panel. A short close delay lets the pointer cross that gap without
	// the panel disappearing.
	var megaMenuHover = function(){
		var item = document.querySelector('.menu-item-mega');
		if(!item) return;

		var closeTimer;
		var open = function(){ clearTimeout(closeTimer); item.classList.add('is-open'); };
		var close = function(){
			clearTimeout(closeTimer);
			closeTimer = setTimeout(function(){ item.classList.remove('is-open'); }, 280);
		};

		item.addEventListener('mouseenter', open);
		item.addEventListener('mouseleave', close);

		var panel = item.querySelector('.mega-menu');
		if(panel){
			panel.addEventListener('mouseenter', open);
			panel.addEventListener('mouseleave', close);
		}

		// Keyboard: close when focus leaves the item entirely.
		item.addEventListener('focusout', function(e){
			if(!item.contains(e.relatedTarget)) close();
		});
	};

	$(document).ready(function(){
		homeHeroSlider();
		heroVideo();
		scrollAnim();
		scrollToAnchor();
		blockGallery();
		faqs();
		reviewsSlider();
		practiceAreaCardExpand();
		practiceAreaFAQ();
		megaMenuHover();
		serviceAreaMap();
		serviceAreaPreview();
	});

    window.addEventListener('load', function() {
        var videoContainer = $('.hero-video-container');
        videoContainer.addClass('vis');
    }, false);

})(jQuery);

/* Lazy load bg images https://web.dev/lazy-loading-images/ */
// document.addEventListener("DOMContentLoaded", function() {
//   var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

//   if ("IntersectionObserver" in window) {
//     let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
//       entries.forEach(function(entry) {
//         if (entry.isIntersecting) {
//           entry.target.classList.add("visible");
//           lazyBackgroundObserver.unobserve(entry.target);
//         }
//       });
//     });

//     lazyBackgrounds.forEach(function(lazyBackground) {
//       lazyBackgroundObserver.observe(lazyBackground);
//     });
//   }
// });